import { lazy, Suspense } from 'react';
import { AthletePracticesRoute } from './routes/athlete-practices-route.js';
import { FamilyPracticesRoute } from './routes/family-practices-route.js';
import { WaitNote } from './components/wait-note.js';

/* The coach's, lazy as the rest of the coach's screens. */
const CoachPracticesRoute = lazy(() =>
  import('./routes/coach-practices-route.js').then((module) => ({ default: module.CoachPracticesRoute })),
);
const coach = (
  <Suspense fallback={<WaitNote className="empty">Opening…</WaitNote>}>
    <CoachPracticesRoute />
  </Suspense>
);

/** Practices (stage 3; boards R1, R2, R5): the athlete's, a parent's and the coach's. */
export const practiceRoutes = [
  { path: 'practices', element: <AthletePracticesRoute /> },
  { path: 'practices/:practiceId', element: <AthletePracticesRoute /> },
  { path: 'account/people/:clientId/practices', element: <FamilyPracticesRoute /> },
  { path: 'account/people/:clientId/practices/:practiceId', element: <FamilyPracticesRoute /> },
  { path: 'coach/clients/:adultAccountId/athletes/:clientId/practices', element: coach },
  { path: 'coach/clients/:adultAccountId/athletes/:clientId/practices/:practiceId', element: coach },
];
